<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.24683 7.34741C8.12817 7.34741 8.84534 6.63037 8.84534 5.74902C8.84534 4.86755 8.12817 4.15051 7.24683 4.15051C6.36548 4.15051 5.64844 4.86755 5.64844 5.74902C5.64844 6.63037 6.36548 7.34741 7.24683 7.34741ZM7.24683 5.08801C7.61133 5.08801 7.90784 5.38452 7.90784 5.74902C7.90784 6.1134 7.61133 6.40991 7.24683 6.40991C6.88245 6.40991 6.58594 6.1134 6.58594 5.74902C6.58594 5.38452 6.88245 5.08801 7.24683 5.08801Z" class="icon-fill"/>
    <path d="M15.4158 1.15625H0.584229C0.262085 1.15625 0 1.41833 0 1.74048V14.2944C0 14.6166 0.262085 14.8787 0.584229 14.8787H15.4158C15.7379 14.8787 16 14.6166 16 14.2944V1.74048C16 1.41833 15.7379 1.15625 15.4158 1.15625ZM15.0625 2.09375V9.5127L12.114 6.56409C11.9218 6.37219 11.6091 6.37231 11.417 6.56445L7.24695 10.7345L4.58325 8.07092C4.49011 7.97766 4.36621 7.92627 4.23438 7.92627C4.10266 7.92627 3.97888 7.97754 3.88574 8.07068L0.9375 11.0189V2.09375H15.0625ZM0.9375 13.9412V12.3447L4.23438 9.04785L6.89795 11.7114C6.99121 11.8047 7.11511 11.8562 7.24695 11.8562C7.37854 11.8562 7.50244 11.8048 7.59546 11.7117L11.7656 7.5415L15.0626 10.8385V13.9412H0.9375Z" class="icon-fill"/>
  </svg>

</template>

<script>
export default {
  name: 'pict'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>